// ShareThis.js
import React, { useEffect } from 'react';

const ShareThis = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://platform-api.sharethis.com/js/sharethis.js#property=667085572bebcc001da49de7&product=inline-share-buttons&source=platform';
        script.async = true;
        script.onload = () => {
            if (window.__sharethis__) {
                window.__sharethis__.load('inline-share-buttons', {
                    id: 'sharethis-inline-share-buttons',
                    enabled: true,
                });
            }
        };

        document.body.appendChild(script);

        return () => {
            // Cleanup script if component is unmounted
            document.body.removeChild(script);
        };
    }, []);

    return <div id="sharethis-inline-share-buttons"></div>;
};

export default ShareThis;
